import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshHolidayService {

  private refreshSubject = new Subject<any>();

  refresh$ = this.refreshSubject.asObservable();

  private refreshSubject2 = new Subject<any>();

  refresh2$ = this.refreshSubject2.asObservable();

  private refreshSubject3 = new Subject<any>();

  refresh3$ = this.refreshSubject3.asObservable();

  emitRefresh(id: number): void {
    this.refreshSubject.next(id);
  }

  emitRefresh2(id: number): void {
    this.refreshSubject2.next(id);
  }

  emitRefresh3(id: number): void {
    this.refreshSubject3.next(id);
  }
}
